<template>
    <div>
        <Header></Header>
        <div class="top-wrapper fadeIn" :style="{ 'background-image': 'url(' + backgroundImageSrc + ')'}">
            <div calss="container" >           
                <div>
                    <h1>必要なものを必要な人へ</h1>
                    <h2>あなたの要らないが<br class="sp_br">誰かの役に立つ</h2>
                    <p>RitsBookは立命館大学生のための<br class="sp_br">教科書フリマアプリです</p>
                    <!-- ボタンを押したらdoLoginを実行 -->
                    <button type="button" @click="doLogin" class="btn login">Googleアカウントでログイン</button><br>
                    <p>または</p><br>
                    <button class="btn register" @click="register()">新規登録</button>
                </div>
            </div>
        </div>
        <Footer class="footer"></Footer>
    </div>
</template>

<script>
import firebase from "firebase"
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'


export default {
    name:'Landing',
    components:{Header, Footer},
    data() {
        return {
            backgroundImageSrc: require("@/assets/landing-background.png"),
            user: {},  // ユーザー情報
        }
    },
    //生成時にログアウトさせる
    created() {
        // firebase.auth().signOut()
        firebase.auth().onAuthStateChanged(user => {
          if(user){
              this.$router.push({path: '/landing'})
          }
        })
    },
    methods: {
        //ログイン処理
        doLogin() {
            const provider = new firebase.auth.GoogleAuthProvider()
            firebase.auth().signInWithPopup(provider)
            // this.$router.push({path: "/landing"})
        },
        // // ログアウト処理
        // doLogout() {
        //   firebase.auth().signOut()
        // },
        //登録画面へ
        register(){
            this.$router.push({path: "/register"})
        }
    }
}
</script>

<style scoped>
* {
    margin: 0; 
    padding: 0;
    box-sizing: border-box;
}

.container {
    width: 100%;
    padding: 0 15px;
    margin: 0 auto;
    background-image: url("~@/assets/landing-background.png"); 
}

.top-wrapper{
    height: 750px;
    padding: 180px 0px 100px 0px;
    text-align: center;
    color: white;
    /* color: aquamarine; */
    background-size: cover;
    background-position: relative;
}

.fadeIn{
animation-name:fadeInAnime;
animation-duration:3s;
animation-fill-mode:forwards;
opacity:0;
}

@keyframes fadeInAnime{
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}


.top-wrapper h1{
    font-size: 40px;
    letter-spacing: 3px;
    margin: 15px 0;
}

.top-wrapper h2{
    font-size: 30px;
    letter-spacing: 3px;
    margin: 15px 0;
}

.sp_br{
    display: none;
}


.login {
    padding: 8px 24px;
    margin: 30px 0;
    /* color: white; */
    /* color: black; */
    /* color: aqua  !important; */
    
    background-color:rgba(255,0, 0);
    display: inline-block;
    opacity: 0.8;
    border-radius: 4px;
    text-align: center;
}

.login:hover {
    background-color:rgba(230,0, 0,1);
    /* background-color: aquamarine; */
}

.register {
    background-color: rgba(53, 174, 243, 1);
}

.register:hover{
    background-color: rgb(50, 120, 160);

}

.btn {
    padding:15px ;
    width: 300px;
    /*margin: 4px 0;*/
    font-weight: bold;
    color: white;
    display: inline-block;
    opacity: 0.8;
    border-radius: 4px;
    text-align: center;
}

.footer {
    /* position: absolute; */
    bottom: 0;
}
    
@media all and (max-width:670px){

    button {
        width: 100px;
    }

    .top-wrapper h1{
        font-size: 26px;
    }

    .top-wrapper h2{
        font-size: 20px;
    }

    .sp_br{
        display: inline;
    }

    .top-wrapper p{
        font-size: 14px;
    }
}
</style>